<script setup lang="ts">
import GwBtn from '../lib/GwBtn/GwBtn.vue'
</script>

<template>
  <div
    class="cntb"
    style="--clr-primary: var(--clr-primary-brand)"
  >
    <div
      class="cntb_inner f-column"
      style="padding: 1rem clamp(1px, 4rem, 12vw); overflow: hidden"
    >
      <div
        class="cntb_inner_back"
        style="z-index: 1"
      ></div>
      <div
        class="f-column py-4 flex-wrap"
        style="position: relative; z-index: 6; gap: 1rem"
      >
        <div class="f-column f-wrap font-poppins">
          <div
            class="f-column"
            style="font-size: clamp(1px, 2.5rem, 8vw)"
          >
            <span>
              <span class="weight_600 text-nowra">
                {{ $t('user_settings.credits_banner_title') }}</span
              >
            </span>
            <div
              class="text-h5 clr-grey mt-1"
              style="max-width: 56rem"
            >
              {{ $t('user_settings.credits_banner_description') }}
            </div>
          </div>
        </div>

        <div class="cntb_bottom_buttons mr-auto d-flex gap-1">
          <GwBtn
            variant="btn_primary-v2-large"
            style="--surface-bg: var(--clr-black-3); --text-clr: var(--clr-white-0)"
            icon="mdi-discord"
          >
            {{ $t('user_settings.credits_banner_discord_button') }}
          </GwBtn>
          <div class="cntb_learn_more text-h7 d-flex">
            <span>
              {{ $t('user_settings.credits_banner_learn_more') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cntb {
  position: relative;
  background: #1d1d1d;
  width: 100%;
  flex-shrink: 0;
  border-radius: 30px;
  &_inner {
    border-radius: 30px;
    background-color: #1f1f1f;
    border: solid var(--clr-black-1) 1px;
    &::before {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 2;
      --opacity: 0.4;
      --back-from: rgba(0, 0, 0, 0.75);
      --back-to: transparent;
      overflow: hidden;

      border-radius: 8px;
    }
    &_back {
      z-index: 0;
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0%;
      z-index: -1;
      background: url('@/assets/img/app_banner_preview_play.webp');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center right;
      border-radius: 8px;
    }
    position: relative;
    display: flex;
    min-height: 12.5rem;
    flex-shrink: 0;
    justify-content: center;
    z-index: 4;
  }

  &_learn_more {
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--clr-primary);
    align-items: center;
    padding: 0 var(--app-pad-4);

    & > span {
      vertical-align: middle;
    }
  }
}
@media (max-width: 1024px) {
  .cntb_inner_back {
    background-position-x: 50%;
  }
}

@media (max-width: 768px) {
  .cntb_inner_back {
    &::before {
      background: linear-gradient(25deg, var(--back-from), var(--back-to) 444%);
    }
    background-size: cover;
    background-position-x: 0;
  }

  .cntb_bottom_buttons {
    flex-direction: column;
  }

  .cntb_learn_more {
    padding: 1rem;
  }
}
@media (max-width: 500px) {
  .cntb_inner_back {
    background-position-x: 50%;
  }
}
</style>
